module.exports = __webpack_public_path__ + "media/images/icons/tab-rounded-corner-right-ec4f662b1a65349fa611e37e1bdd8254.svg";